import { createAction } from "@ngrx/store";
import { SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { MenuItemGroup, MenuResponse } from "./menu.model";

const ACTION_PREFIX = "[Menu]";
/**
 * @deprecated [fabric-deprecated] - Use fabric ContentService from svc-content instead
 */
export namespace MenuAction {
	/**
	 * @deprecated [fabric-deprecated] - Use fabric ContentService from svc-content instead
	 */
	export const getAllByName = createAction(
		`${ACTION_PREFIX} Get Menu Items ${SYNC_SUFFIX}`,
		(menuNames: string[]) => ({ payload: menuNames, menuNames })
	);

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ContentService from svc-content instead
	 */
	export const fetchAllByName = createAction(`${ACTION_PREFIX} Fetch Menu Items`, (menuNames: string[]) => ({
		payload: menuNames,
		menuNames,
	}));

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ContentService from svc-content instead
	 */
	export const fetchSuccess = createAction(
		`${ACTION_PREFIX} Fetch Menu Items Success`,
		(keysLoaded: string[], menus: Record<string, MenuItemGroup>) => ({
			payload: {
				menus,
				keysLoaded,
			},
		})
	);

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ContentService from svc-content instead
	 */
	export const menuItemsFetched = createAction(
		`${ACTION_PREFIX} Items Fetched`,
		(menus: MenuResponse, menuNames: string[]) => ({ payload: { menus, menuNames } })
	);

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ContentService from svc-content instead
	 */
	export const fetchFail = createAction(`${ACTION_PREFIX} Fetch Menu Items Fail`, (error: AppError) => ({
		payload: error,
		error,
	}));

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ContentService from svc-content instead
	 */
	export const setNotificationsCount = createAction(
		`${ACTION_PREFIX} Set Menu Item Notifications Count ${SYNC_SUFFIX}`,
		(menuItemKeys: string[], count: number) => ({
			payload: {
				menuItemKeys,
				count,
			},
		})
	);
}
